// extracted by mini-css-extract-plugin
export default {"preLoader":"PreLoader_preLoader__IF1tO","logoVis":"PreLoader_logoVis__KjzsM"};